module.exports = __webpack_public_path__ + "img/trunk-dunk-intro.cbc407d3.jpg";